/**
 * Canada Post Fields
 * List of fields for cpost, used if it's the user's current address
 * Used with the Candada Post AddressSelect lib
 */
const cpostFields = [{
  key: 'FormattedLine1',
  field: 'street_address',
  vuexAction: 'setStreetAddress'
}, {
  key: 'Label',
  field: 'c_post_fullAddress',
  vuexAction: 'setCPostFullAddress'
}, {
  key: 'Company',
  field: 'c_post_Company',
  vuexAction: 'setCPostCompany'
}, {
  key: 'BuildingName',
  field: 'c_post_BuildingName',
  vuexAction: 'setCPostBuildingName'
}, {
  key: 'BuildingNumber',
  field: 'c_post_BuildingNumber',
  vuexAction: 'setCPostBuildingNumber'
}, {
  key: 'Line1',
  field: 'c_post_Line1',
  vuexAction: 'setCPostLine1'
}, {
  key: 'Line2',
  field: 'c_post_Line2',
  vuexAction: 'setCPostLine2'
}, {
  key: 'Line3',
  field: 'c_post_Line3',
  vuexAction: 'setCPostLine3'
}, {
  key: 'Line4',
  field: 'c_post_Line4',
  vuexAction: 'setCPostLine4'
}, {
  key: 'Line5',
  field: 'c_post_Line5',
  vuexAction: 'setCPostLine5'
}, {
  key: 'District',
  field: 'c_post_District',
  vuexAction: 'setCPostDistrict'
}, {
  key: 'SubBuilding',
  field: 'c_post_SubBuilding',
  vuexAction: 'setCPostSubBuilding'
}, {
  key: 'Street',
  field: 'c_post_Street',
  vuexAction: 'setCPostStreet'
}, {
  key: 'City',
  field: 'city',
  vuexAction: 'setCity'
}, {
  key: 'City',
  field: 'c_post_City',
  vuexAction: 'setCPostCity'
}, {
  key: 'Province',
  field: 'c_post_Province',
  vuexAction: 'setCPostProvince'
}, {
  key: 'Province',
  field: 'province',
  vuexAction: 'setProvince'
}, {
  key: 'ProvinceName',
  field: 'c_post_ProvinceName',
  vuexAction: 'setCPostProvinceName'
}, {
  key: 'ProvinceCode',
  field: 'c_post_ProvinceCode',
  vuexAction: 'setCPostProvinceCode'
}, {
  key: 'CountryName',
  field: 'country',
  vuexAction: 'setCountry'
}, {
  key: 'CountryName',
  field: 'c_post_CountryName',
  vuexAction: 'setCPostCountryName'
}, {
  key: 'PostalCode',
  field: 'postal_code',
  vuexAction: 'setPostalCode'
}, {
  key: 'PostalCode',
  field: 'c_post_PostalCode',
  vuexAction: 'setCPostPostalCode'
}, {
  key: 'verified',
  field: 'c_post_verified',
  vuexAction: 'setCpostVerified'
}, {
  key: 'error',
  field: 'c_post_error',
  vuexAction: 'setCPostError'
}, {
  key: 'errorDescription',
  field: 'c_post_error_description',
  vuexAction: 'setCPostErrorDescription'
}]

export default cpostFields
